import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Form from 'react-jsonschema-form'
import { jsonSchema, uiSchema, prepFormData } from './schemas/defaultSchema'
import transformErrors from './transformErrors'
import FieldTemplate from './FieldTemplate'
import AltCheckboxWidget from './fields/AltCheckboxWidget'
import fetchPardot from './fetchPardot'
import { styles as datePickerStyles } from './fields/ReactDatePicker'

class Scroll extends Component {
  constructor(props) {
    super(props)
    this.scrollRef = React.createRef()
  }
  scrollTo(element, offSet = 0, timeout = null) {
    const elemPos = element
      ? element.getBoundingClientRect().top + window.pageYOffset
      : 0
    if (timeout) {
      setTimeout(() => {
        window.scroll({ top: elemPos + offSet, left: 0, behavior: 'smooth' })
      }, timeout)
    } else {
      window.scroll({ top: elemPos + offSet, left: 0, behavior: 'smooth' })
    }
  }
  componentDidMount() {
    this.componentDidUpdate()
  }
  componentDidUpdate() {
    this.scrollTo(this.scrollRef.current, -100)
  }
  render() {
    return <div ref={this.scrollRef}>{this.props.children}</div>
  }
}

export class SignupForm extends Component {
  render() {
    const props = this.props
    const widgets = props.widgets || {}
    if (!widgets['alt-checkbox']) {
      widgets['alt-checkbox'] = AltCheckboxWidget
    }
    // console.log(this.props)
    return (
      <div>
        <style>{`
          .cid-signup-form,
          .cid-signup-form .form-control {
            font-size: 16px;
          }
          .cid-signup-form .text-danger {
            color: #a94442;
          }
          .cid-signup-form .has-error .form-control {
            border-color: #a94442;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
          }
          .cid-signup-form-verification {
            position: absolute;
            left: -9999px;
            top: -9999px;
          }
          .cid-signup-form fieldset,
          .cid-signup-form legend {
            padding: 0;
            border: 0;
          }
          .cid-signup-form-group {
            border: 0;
            margin: 0 0 1em;
            padding: 0;
          }
          .cid-signup-form-group-hidden {
            display: none;
          }
          .cid-signup-form label {
            font-size: 0.9375em;
            margin-bottom: 0.5em;
          }
          .cid-signup-form .checkboxes label {
            font-size: 0.875em;
            margin-bottom: 0.5em;
          }
          .cid-signup-form .checkbox input[type=checkbox] {
            margin: 3px 0.5ex;
          }
          .cid-signup-form label,
          .cid-signup-form .form-control,
          .cid-signup-form .form-group legend {
            box-sizing: border-box;
            display: block;
            width: 100%;
          }
          .cid-signup-form .form-control {
            padding: 0.5em 0.75em;
            line-height: 1.25;
            background-clip: padding-box;
            border: 1px solid rgba(0,0,0,.15);
            border-radius: 0.25em;
            transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
          }
          .cid-signup-form .field-description,
          .cid-signup-form .form-text,
          .cid-signup-form .form-check-label,
          .cid-signup-form label.form-check-label {
            font-size: 0.875em;
          }
          .cid-signup-form .form-check {
            margin-bottom: 0.25em;
          }
          .cid-signup-form-submit {
            background-color: #333333;
            border-color: #222222;
            color: #ffffff;
            font-weight: 600;
            padding: .5em 1em;
            display: inline-block;
            font-weight: 400;
            font-size: 1em;
            line-height: 1.25;
            margin-bottom: 0.5em;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            user-select: none;
            border: 1px solid transparent;
            border-radius: .25em;
            transition: all .2s ease-in-out;
          }
          .cid-signup-form-submit:hover {
            background-color: #000000;
            border-color: #111111;
            box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075);
            color: #ffffff;
          }
          ${datePickerStyles}
        `}</style>
        <Form
          className="cid-signup-form"
          method="post"
          showErrorList={false}
          transformErrors={transformErrors}
          // ErrorList={ErrorListTemplate}
          FieldTemplate={FieldTemplate}
          {...this.props}
        >
          <button
            type="submit"
            className="cid-signup-form-submit btn btn-primary"
            {...(props.submitting ? { disabled: true } : {})}
          >
            {props.submitLabel}
          </button>
          {props.hasErrors && props.hasErrorsMessage ? (
            <p className="text-danger">{props.hasErrorsMessage}</p>
          ) : null}
        </Form>
      </div>
    )
  }
}
SignupForm.propTypes = {
  schema: PropTypes.object,
  uiSchema: PropTypes.object,
  formData: PropTypes.object,
  idPrefix: PropTypes.string,
  className: PropTypes.string,
  hasErrors: PropTypes.bool,
  hasErrorsMessage: PropTypes.string,
  submitLabel: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
}
SignupForm.defaultProps = {
  hasErrors: false,
  submitLabel: 'Subscribe',
  submitting: false,
}

export default class SignupFormContainer extends Component {
  constructor(props) {
    super()
    this.state = {
      hasErrors: props.hasErrors || false,
      submitting: props.submitting || false,
      submitLabel: props.submitLabel,
      success: props.success || false,
    }
    // Create a clone of the default uiSchema if none is
    // provided so we don't mutate the default and don't
    // mutate the incoming props object.
    this.uiSchema = null
    if (props.uiSchema) {
      this.uiSchema = { ...props.uiSchema }
    }
    if (!this.uiSchema) {
      this.uiSchema = { ...uiSchema }
    }
    if (props.idPrefix) {
      this.uiSchema['ui:rootFieldId'] = props.idPrefix
    }

    this.hidePreferences = props.hidePreferences
  }

  submitHandler = submitData => {
    const { formData } = submitData
    let preppedFormData = formData
    if (this.props.prepFormData) {
      preppedFormData = this.props.prepFormData(formData, {
        hidePreferences: this.hidePreferences,
      })
    }
    if (!this.props.action) {
      if (this.props.submitHandler) {
        return this.props.submitHandler(preppedFormData, this)
      }
      return
    }
    this.setState({
      hasErrors: false,
      submitting: true,
      submitLabel: 'Sending...',
    })
    fetchPardot(this.props.action, preppedFormData)
      .then(response => {
        return response.json()
      })
      .then(json => {
        if (this.props.onSuccess) {
          this.props.onSuccess(preppedFormData)
        }
        this.setState({
          success: true,
          submitting: false,
          submitLabel: this.props.submitLabel,
        })
      })
      .catch(error => {
        this.setState({
          success: false,
          submitting: false,
          submitLabel: this.props.submitLabel,
        })
      })
  }

  errorHandler = errors => {
    this.setState({
      hasErrors: true,
    })
    // console.error('errors', errors)
  }

  render() {
    const props = this.props
    const { hasErrors, submitting, submitLabel, success } = this.state
    // console.log('props', props)
    return success ? (
      <Scroll>
        {props.successElement ? (
          <div className="text-success">{props.successElement}</div>
        ) : (
          <div
            className="text-success"
            dangerouslySetInnerHTML={{ __html: props.successHtml }}
          />
        )}
      </Scroll>
    ) : (
      <SignupForm
        {...props}
        hasErrors={hasErrors}
        submitting={submitting}
        submitLabel={submitLabel}
        uiSchema={this.uiSchema}
        onSubmit={props.onSubmit || this.submitHandler}
        onError={props.errorHandler || this.submitHandler}
      />
    )
  }
}
// https://reactjs.org/docs/typechecking-with-proptypes.html
SignupFormContainer.propTypes = {
  schema: PropTypes.object,
  uiSchema: PropTypes.object,
  formData: PropTypes.object,
  idPrefix: PropTypes.string,
  className: PropTypes.string,
  hidePreferences: PropTypes.bool,
  hasErrorsMessage: PropTypes.string,
  submitLabel: PropTypes.string,
  prepFormData: PropTypes.func,
  onSuccess: PropTypes.func, // called after a successful submit if you use the default submitHandler
  onSubmit: PropTypes.func, // override the default form handler
  // ^^^ it includes prepping the form data
  // really only used for testing, most likely you
  // want to just override prepFormData, submitHandler,
  // or add a onSuccess
  submitHandler: PropTypes.func, // override the default submit handler that sends data to pardot
  onError: PropTypes.func, // override the default error handler
  successHtml: PropTypes.string,
  successElement: PropTypes.element,
}
SignupFormContainer.defaultProps = {
  schema: jsonSchema,
  prepFormData: prepFormData,
  hidePreferences: false,
  hasErrorsMessage:
    'Sorry, your form was not submitted. Please check above for error messages and re-submit.',
  action: 'https://go.pardot.com/l/392642/2018-09-11/7fbrqj',
  successHtml: "Thanks for signing up. We'll be in touch soon.",
}
export { SignupFormContainer }
